function MailboxIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
      <path
        d="M18.125 16.25H1.875C0.8375 16.25 0 15.4125 0 14.375V3.125C0 
      2.0875 0.8375 1.25 1.875 1.25H18.125C19.1625 1.25 20 2.0875 20 
      3.125V14.375C20 15.4125 19.1625 16.25 18.125 16.25ZM1.875 2.5C1.525 
      2.5 1.25 2.775 1.25 3.125V14.375C1.25 14.725 1.525 15 1.875 15H18.125C18.475 
      15 18.75 14.725 18.75 14.375V3.125C18.75 2.775 18.475 2.5 18.125 2.5H1.875Z"
        fill="black"
      />
      <path
        d="M10.0003 11.1993C9.12527 11.1993 8.32527 10.8493 
      7.72527 10.2118L1.16277 3.23679C0.92527 2.98679 0.93777 2.58679 
      1.18777 2.34929C1.43777 2.11179 1.83777 2.12429 2.07527 2.37429L8.63777 
      9.3493C9.35027 10.1118 10.6503 10.1118 11.3628 9.3493L17.9253 2.38679C18.1628 
      2.13679 18.5628 2.12429 18.8128 2.36179C19.0628 2.59929 19.0753 2.99929 18.8378 
      3.24929L12.2753 10.2243C11.6753 10.8618 10.8753 11.2118 10.0003 11.2118V11.1993Z"
        fill="black"
      />
    </svg>
  );
}

export default MailboxIcon;
